import { FC, PropsWithChildren, useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import { PageLayout } from '@/components'
import { Header } from '@/components/Header'
import Sidebar from './Sidebar'
import { useAppSelector } from '@/store'

const Page: FC<PropsWithChildren> = () => {
  const { pathname } = useLocation()
  const { isSidebarCollapsed } = useAppSelector((s) => s.app)

  useEffect(() => {
    document.body.scrollTop = 0
  }, [pathname])

  useEffect(() => {
    const handleWheel = () => {
      const numberInput = document.activeElement as HTMLInputElement
      if (numberInput?.type === 'number') {
        numberInput.blur()
      }
    }
    document.addEventListener('wheel', handleWheel)
    return () => {
      document.removeEventListener('wheel', handleWheel)
    }
  }, [])

  return (
    <PageLayout showHeader={false} showFooter={false}>
      <Sidebar collapsed={isSidebarCollapsed} />
      <Outlet />
    </PageLayout>
  )
}

export default Page
